import { Card, Divider } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { CustomJobPhase } from "hooks/jobs/job-phases/useGetJobPhase";
import JobCostingSummaryTable from "./JobCostingSummaryTable";
import JobCostingVisibilitySummary from "./JobCostingVisibilitySummary";
import { buildSummaryMetrics } from "./jobCostingSummaryUtils";

export default function JobCostingSection({
  jobPhase,
  onHelpClick,
}: {
  jobPhase: CustomJobPhase;
  onHelpClick?: () => void;
}) {
  const summary = buildSummaryMetrics(jobPhase);

  return (
    <Card className="tour-job-costing-summary">
      <MDBox sx={{ p: { xs: 2, md: 3 }, overflow: "auto", maxWidth: "100%" }}>
        <JobCostingVisibilitySummary jobPhase={jobPhase} onHelpClick={onHelpClick} />
        <Divider sx={{ my: 3 }} />
        <MDTypography variant="h6" fontWeight="medium" mb={2}>
          Job Costing Summary
        </MDTypography>
        <JobCostingSummaryTable costItems={jobPhase?.costItems} summary={summary} />
      </MDBox>
    </Card>
  );
}
